import { useRouter } from "next/router";
import { useMemberOrchestrator } from "@nju/data-access-portal-member";
import { portalRoutes } from "@nju/routes";
import { GeneralErrorNotification } from "@nju/ui";
import { PaymentForm } from "./PaymentForm";

export function PaymentPage() {
  const router = useRouter();
  const memberOrchestrator = useMemberOrchestrator();

  if (!memberOrchestrator?.mobile) {
    return (
      <GeneralErrorNotification
        callback={() => {
          router.push(portalRoutes.mojeKonto.index.get({ mode: "mobile" }));
        }}
      />
    );
  }

  return <PaymentForm orchestrator={memberOrchestrator?.mobile} />;
}
